import React, {ForwardedRef} from "react";
import {IMaskInput} from "react-imask";

export const MaskedInput = React.forwardRef(function TextMaskCustom(props: {
    mask: string,
    children?: React.ReactNode;
}, ref: ForwardedRef<HTMLInputElement>) {

    const {mask, ...other} = props;

    return (
        <IMaskInput
            {...other}
            mask={mask}
            definitions={{
                '#': /[1-9]/,
            }}
            inputRef={ref}
            overwrite
        />
    );
});

